var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 170,
    viewBox: "0 0 127 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.8523C98.1619 57.8523 102.555 120.953 63.0168 120.953C23.4783 120.953 26.6511 57.8523 26.6511 57.8523C26.6511 57.8523 24.7416 20.3247 64.3549 20.3247C101.227 20.3247 98.1619 57.8523 98.1619 57.8523Z",
    fill: "#F6F6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1619 57.8523C98.1619 57.8523 102.555 120.953 63.0168 120.953C23.4783 120.953 26.6511 57.8523 26.6511 57.8523C26.6511 57.8523 24.7416 20.3247 64.3549 20.3247C101.227 20.3247 98.1619 57.8523 98.1619 57.8523Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.13,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6863 77.8888V83.9695C60.6863 84.3939 60.7686 84.803 60.9179 85.1771C61.5062 86.6464 63.2008 87.349 64.7323 86.9414L66.5153 86.4699",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3231 70.3525C51.3231 72.1594 49.8556 73.6241 48.0451 73.6241C46.2347 73.6241 44.7656 72.1594 44.7656 70.3525C44.7656 68.5472 46.2347 67.081 48.0451 67.081C49.8556 67.081 51.3231 68.5472 51.3231 70.3525Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8733 70.3525C81.8733 72.1594 80.4057 73.6241 78.5953 73.6241C76.7849 73.6241 75.3158 72.1594 75.3158 70.3525C75.3158 68.5472 76.7849 67.081 78.5953 67.081C80.4057 67.081 81.8733 68.5472 81.8733 70.3525Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5944 94.2137C55.5944 94.2137 58.816 96.2213 63.0647 96.2213C67.3134 96.2213 70.535 94.2137 70.535 94.2137",
    stroke: "#1A1A1A",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9292 57.5908C55.7585 57.9194 54.9493 61.9255 54.9493 61.9255L36.9181 63.8617L41.2171 60.7802C42.3144 60.0761 43.5381 59.5863 44.8182 59.3399L55.9292 57.5908Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7085 57.5908C68.8792 57.9194 69.6884 61.9255 69.6884 61.9255L87.7196 63.8617L83.4206 60.7802C82.3234 60.0761 81.1012 59.5863 79.8195 59.3399L68.7085 57.5908Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.7473C98.0861 93.4203 103.249 91.0173 106.242 86.2354C109.237 81.4551 110.634 71.893 106.242 69.3028C101.852 66.7112 98.1501 72.0512 98.1501 72.0512C98.1501 72.0512 97.0819 81.7183 96.3031 85.3335L95.4116 89.7473Z",
    fill: "#F6F6F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4116 89.7473C98.0861 93.4203 103.249 91.0173 106.242 86.2354C109.237 81.4551 110.634 71.893 106.242 69.3028C101.852 66.7112 98.1501 72.0512 98.1501 72.0512C98.1501 72.0512 97.0819 81.7183 96.3031 85.3335L95.4116 89.7473Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9713 80.9439C100.484 73.6708 105.763 75.2784 105.763 75.2784",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7037 77.3466C99.7037 77.3466 105.088 80.2212 101.531 84.5391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.7087C26.652 93.3803 21.8181 91.0167 18.8236 86.2364C15.8306 81.4546 14.4331 71.8924 18.8236 69.3023C23.2156 66.7121 26.9172 72.0521 26.9172 72.0521",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.325 89.7087C26.652 93.3803 21.8181 91.0167 18.8236 86.2364C15.8306 81.4546 14.4331 71.8924 18.8236 69.3023C23.2156 66.7121 26.9172 72.0521 26.9172 72.0521",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3048 75.2791C19.3048 75.2791 24.2546 73.632 27.7657 80.9036",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3633 77.3466C25.3633 77.3466 19.9793 80.2212 23.5361 84.5391",
    stroke: "#1A1A1A",
    strokeWidth: 0.575,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1232 17.246C74.4118 13.8969 68.1179 12.6817 62.3681 12.9068C56.6198 12.6817 50.3259 13.8969 43.613 17.246C13.8962 32.0751 26.298 71.7199 26.298 71.7199L26.4443 70.0088C27.3282 68.8438 32.1499 62.173 34.157 53.2298H90.2607C92.2738 64.0772 97.8652 70.5396 98.0648 71.1206C98.1379 70.3617 98.1776 69.5708 98.2035 68.7662L98.8771 71.7199C98.8771 71.7199 110.841 32.0751 81.1232 17.246Z",
    fill: "#1A1A1A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.238 8.87626C104.238 20.7411 94.601 30.361 82.7112 30.361C70.8215 30.361 61.1841 20.7411 61.1841 8.87626C61.1841 -2.99009 70.8215 -12.61 82.7112 -12.61C94.601 -12.61 104.238 -2.99009 104.238 8.87626Z",
    fill: "#1A1A1A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 153.404C107.436 153.404 81.2185 147.638 79.3792 139.084V116.247",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4715 116.19V139.085C46.4715 139.085 39.2587 149.914 19.4811 153.334",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.508 207.056C147.508 177.965 118.809 159.154 110.283 154.206C108.908 153.409 107.215 153.418 105.867 154.261C96.9196 159.855 60.0464 179.601 20.4637 153.7C19.7139 153.208 18.7584 153.16 17.9751 153.596C11.1631 157.392 -20.3199 176.585 -20.3199 207.056",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.508 207.056C147.508 177.965 118.809 159.154 110.283 154.206C108.908 153.409 107.215 153.418 105.867 154.261C96.9196 159.855 60.0464 179.601 20.4637 153.7C19.7139 153.208 18.7584 153.16 17.9751 153.596C11.1631 157.392 -20.3199 176.585 -20.3199 207.056",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3541 150.216C31.3541 150.216 58.9892 166.287 95.4585 150.137",
    stroke: "#1A1A1A",
    strokeWidth: 1.149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6106 116.411C46.6106 116.411 53.4409 131.671 67.2965 130.699C67.2965 130.699 77.1777 130.606 79.5185 120.794L78.5447 116.411C78.5447 116.411 66.0819 125.27 46.6106 116.411Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.ed7b9e2c99aeebed844c1560f3aab731.svg";
export { ForwardRef as ReactComponent };